// extracted by mini-css-extract-plugin
module.exports = {"usersTable":"GroupManagement_usersTable__CL_om","overflow":"GroupManagement_overflow__274RM"};